import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
// import classnames from 'classnames';
import _ from 'lodash'

import Money from '../../../../../../../../../../../components/TableCell/components/Money'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'
import Counter from '../../../../../../../../../../../components/Counter'

export default class Summary extends Component {
    static propTypes = {
        data: PropTypes.object,
    }

    renderAmounts = (inputArr) => {
        const mapArr = _.isEmpty(inputArr) ? [{ amount: 0, currency: 'CZK' }] : inputArr

        return _.map(mapArr, (amount, index) => (
            <div className={'row'} key={`amount-row-${index}`}>
                <div className={'amount-container'}>
                    <div className={'amount'}>
                        <Money value={amount} currencyStyle={{ fontSize: '35px' }} emptyValue={0} />
                    </div>
                </div>
            </div>
        ))
    }

    render() {
        const { data } = this.props

        const czCustomerRoles = _.get(data, 'czechCountry.customerRoles', 0)
        const czSupplierRoles = _.get(data, 'czechCountry.supplierRoles', 0)
        const skCustomerRoles = _.get(data, 'slovakiaCountry.customerRoles', 0)
        const skSupplierRoles = _.get(data, 'slovakiaCountry.supplierRoles', 0)
        const notIncludedContracts = _.get(data, 'totalCounts.notIncludedContracts', 0)
        const totalContracts = _.get(data, 'totalCounts.totalContracts', 0)

        return (
            <div className={'contracts-summary-container'}>
                <div className={'rows-container'}>
                    <div className={'contracts-row'}>
                        {(czCustomerRoles > 0 || czSupplierRoles > 0) && (
                            <div className={'contracts-section-container'}>
                                <div className={'title-container'}>
                                    <div className={'flag-icon flag-icon-cz'} />
                                    <span className={'text with-flag'}>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.czRegisters`} />
                                    </span>
                                </div>
                                <div className={'value-container'}>
                                    <Counter
                                        twoValues
                                        leftValue={{
                                            value: czCustomerRoles,
                                        }}
                                        separator={'|'}
                                        rightValue={{
                                            value: czSupplierRoles,
                                            style: { fontFamily: 'Trivia Sans Black, sans-serif' },
                                        }}
                                        description={
                                            <FormattedMessage
                                                id={`${LOCALE_PREFIX}.bothRolesContracts`}
                                                values={{ br: <br /> }}
                                            />
                                        }
                                    />
                                </div>
                                {(notIncludedContracts > 0 || totalContracts > 0) && (
                                    <div className={'risk-container'}>
                                        <Counter
                                            customClassName={'risk-counter'}
                                            twoValues
                                            leftValue={{
                                                value: notIncludedContracts,
                                                style: {
                                                    color: '#DF1F1F',
                                                    fontFamily: 'Trivia Sans Light, sans-serif',
                                                },
                                            }}
                                            separatorStyle={{
                                                color: '#DF1F1F',
                                                fontFamily: 'Trivia Sans Light, sans-serif',
                                            }}
                                            rightValue={{
                                                value: totalContracts,
                                                style: {
                                                    color: '#DF1F1F',
                                                    fontFamily: 'Trivia Sans Light, sans-serif',
                                                },
                                            }}
                                            description={
                                                <div className={'value-description'}>
                                                    <FormattedMessage
                                                        id={`${LOCALE_PREFIX}.notIncludedContracts`}
                                                        values={{ br: <br /> }}
                                                    />
                                                    <Tooltip
                                                        id={'contracts-summary-context-not-included-contracts'}
                                                        content={
                                                            <FormattedMessage
                                                                id={`${LOCALE_PREFIX}.notIncludedContractsTooltip`}
                                                            />
                                                        }
                                                        position={POSITION.TOP}
                                                        align={ALIGN.CENTER}
                                                        width={'250px'}
                                                        automaticAlignChange
                                                    >
                                                        <div className={'help'} />
                                                    </Tooltip>
                                                </div>
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                        {(skCustomerRoles > 0 || skSupplierRoles > 0) && (
                            <div className={'contracts-section-container'}>
                                <div className={'title-container'}>
                                    <div className={'flag-icon flag-icon-sk'} />
                                    <span className={'text with-flag'}>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.skRegisters`} />
                                    </span>
                                </div>
                                <div className={'value-container'}>
                                    <Counter
                                        twoValues
                                        leftValue={{
                                            value: skCustomerRoles,
                                        }}
                                        separator={'|'}
                                        rightValue={{
                                            value: skSupplierRoles,
                                            style: { fontFamily: 'Trivia Sans Black, sans-serif' },
                                        }}
                                        description={
                                            <FormattedMessage
                                                id={`${LOCALE_PREFIX}.bothRolesContracts`}
                                                values={{ br: <br /> }}
                                            />
                                        }
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    {/* <div className={'contracts-row'}>
                        {(czCustomerRoles > 0 || czSupplierRoles > 0) && (
                            <div className={'contracts-section-container'}>
                                <div className={'title-container'}>
                                    <span className={'text small'}>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.subscriberContracts`} />
                                        <Tooltip
                                            id={'contracts-summary-context-help-cz-subscriber-contracts'}
                                            content={<FormattedMessage id={`${LOCALE_PREFIX}.contextHelp`} />}
                                            position={POSITION.TOP}
                                            align={ALIGN.CENTER}
                                            width={'250px'}
                                            automaticAlignChange
                                        >
                                            <div className={'help'} />
                                        </Tooltip>
                                    </span>
                                </div>
                                <div className={'value-container'}>
                                    {this.renderAmounts(_.get(data, 'czechCountry.customerContractsAmounts', []))}
                                </div>
                            </div>
                        )}
                        {(skCustomerRoles > 0 || skSupplierRoles > 0) && (
                            <div className={'contracts-section-container'}>
                                <div className={'title-container'}>
                                    <span className={'text small'}>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.subscriberContracts`} />
                                        <Tooltip
                                            id={'contracts-summary-context-help-sk-subscriber-contracts'}
                                            content={<FormattedMessage id={`${LOCALE_PREFIX}.contextHelp`} />}
                                            position={POSITION.TOP}
                                            align={ALIGN.CENTER}
                                            width={'250px'}
                                            automaticAlignChange
                                        >
                                            <div className={'help'} />
                                        </Tooltip>
                                    </span>
                                </div>
                                <div className={'value-container'}>
                                    {this.renderAmounts(_.get(data, 'slovakiaCountry.customerContractsAmounts', []))}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={'contracts-row'}>
                        {(czCustomerRoles > 0 || czSupplierRoles > 0) && (
                            <div className={'contracts-section-container'}>
                                <div className={'title-container'}>
                                    <span className={'text small'}>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.supplierContracts`} />
                                        <Tooltip
                                            id={'contracts-summary-context-help-cz-supplier-contracts'}
                                            content={<FormattedMessage id={`${LOCALE_PREFIX}.contextHelp`} />}
                                            position={POSITION.TOP}
                                            align={ALIGN.CENTER}
                                            width={'250px'}
                                            automaticAlignChange
                                        >
                                            <div className={'help'} />
                                        </Tooltip>
                                    </span>
                                </div>
                                <div className={'value-container'}>
                                    {this.renderAmounts(_.get(data, 'czechCountry.supplierContractsAmounts', []))}
                                </div>
                            </div>
                        )}
                        {(skCustomerRoles > 0 || skSupplierRoles > 0) && (
                            <div className={'contracts-section-container'}>
                                <div className={'title-container'}>
                                    <span className={'text small'}>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.supplierContracts`} />
                                        <Tooltip
                                            id={'contracts-summary-context-help-sk-supplier-contracts'}
                                            content={<FormattedMessage id={`${LOCALE_PREFIX}.contextHelp`} />}
                                            position={POSITION.TOP}
                                            align={ALIGN.CENTER}
                                            width={'250px'}
                                            automaticAlignChange
                                        >
                                            <div className={'help'} />
                                        </Tooltip>
                                    </span>
                                </div>
                                <div className={'value-container'}>
                                    {this.renderAmounts(_.get(data, 'slovakiaCountry.supplierContractsAmounts', []))}
                                </div>
                            </div>
                        )}
                    </div> */}
                </div>
            </div>
        )
    }
}
